"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const parse_dimension_value_1 = require("./parse-dimension-value");
const calculate_ratio_1 = require("./calculate-ratio");
const pipe = (...fns) => (initial) => fns.reduce((prev, fn) => fn(prev), initial);
function changeContainerDimensions() {
    return (state, actions, { tabName = state.ui.currentTabName, dimensionType, changes }) => () => {
        const currentDimensions = dimensionType === 'original'
            ? state.tabs[tabName].originalContainerDimensions
            : state.tabs[tabName].containerDimensions;
        const newDimensions = pipe(changesToDimensions(changes), resetValueForAutoFormat(), recalculateValueForRatioLock(state.ui.tabs[tabName].aspectRatioLocked, state.ui.tabs[tabName].aspectRatioLockedRatio, changes), recalculateRatio())(currentDimensions);
        actions.setters.setContainerDimensions({ tabName, dimensionType, changes: newDimensions });
        actions.effects.recalculateWarnings({ tabName });
    };
}
exports.changeContainerDimensions = changeContainerDimensions;
function recalculateValueForRatioLock(aspectRatioLocked, aspectRatioLockedRatio, changes) {
    return (currentDimensions) => {
        if (!aspectRatioLocked) {
            return currentDimensions;
        }
        if (!changes.widthValue && !changes.heightValue) {
            return currentDimensions;
        }
        if (currentDimensions.heightFormat !== 'px' || currentDimensions.widthFormat !== 'px') {
            return currentDimensions;
        }
        let newWidth = changes.widthValue ? currentDimensions.widthValue : 0;
        let newHeight = changes.heightValue ? currentDimensions.heightValue : 0;
        const ratio = aspectRatioLockedRatio &&
            aspectRatioLockedRatio.widthValue &&
            aspectRatioLockedRatio.heightValue &&
            aspectRatioLockedRatio.widthValue / aspectRatioLockedRatio.heightValue;
        if (ratio === Infinity || !ratio) {
            return currentDimensions;
        }
        if (newWidth) {
            newHeight = newWidth / ratio;
        }
        else if (newHeight) {
            newWidth = newHeight * ratio;
        }
        return Object.assign({}, currentDimensions, { widthValue: newWidth === undefined ? undefined : Math.floor(newWidth), heightValue: newHeight === undefined ? undefined : Math.floor(newHeight) });
    };
}
function changesToDimensions(changes) {
    return (currentDimensions) => {
        return Object.keys(changes).reduce((newDimensions, changeKey) => {
            switch (changeKey) {
                case 'widthValue':
                case 'heightValue':
                    newDimensions[changeKey] = parse_dimension_value_1.parseDimensionValue(changes[changeKey]);
                    break;
                case 'widthFormat':
                case 'heightFormat':
                    newDimensions[changeKey] = changes[changeKey];
                    break;
            }
            return newDimensions;
        }, Object.assign({}, currentDimensions));
    };
}
function resetValueForAutoFormat() {
    return (currentDimensions) => {
        const newDimensions = Object.assign({}, currentDimensions);
        if (newDimensions.widthFormat === 'auto') {
            newDimensions.widthValue = undefined;
        }
        if (newDimensions.heightFormat === 'auto') {
            newDimensions.heightValue = undefined;
        }
        return newDimensions;
    };
}
function recalculateRatio() {
    return (currentDimensions) => {
        const ratio = calculate_ratio_1.calculateRatio({
            widthFormat: currentDimensions.widthFormat,
            widthValue: currentDimensions.widthValue,
            heightFormat: currentDimensions.heightFormat,
            heightValue: currentDimensions.heightValue,
        });
        return Object.assign({}, currentDimensions, { ratio });
    };
}
//# sourceMappingURL=change-container-dimensions.js.map